<template>
  <v-flex>   
    <v-layout row>
      <v-flex xs12 sm2>
        <v-select class="ma-2" style="margin-right:100px" dark outline v-model="selectedVisualItem" :items="visualItems" label="Select" single-line item-text="fieldName" persistent-hint return-object @input="selectVisualItem"></v-select>
      </v-flex>
      <v-flex xs12 sm2  v-if="selectedVisualItem && selectedVisualItem.type === 'selection'">
        <v-select single-line class="ma-2" dark outline v-model="condition.selectionValue" :items="selectedVisualItem.values" persistent-hint ></v-select>
      </v-flex>
      <v-flex xs12 sm5 v-if="selectedVisualItem && selectedVisualItem.type === 'string'">
        <v-text-field dark v-model="condition.stringValue" label="Enter Value."></v-text-field>
      </v-flex>
      <v-flex xs12 sm5 style="line-height:1; border-radius:20px" sm6 v-if="selectedVisualItem && selectedVisualItem.type === 'scale'">
        <v-range-slider
            dark
            v-model="sliderModel"
            :max="selectedVisualRangeMax"
            :min="selectedVisualRangeMin"
            hide-details
            step="1"
            class="align-center ma-1 pl-4"
            @change="sliderChanged"
          >
            <template v-slot:prepend>
              <v-text-field
                outline
                v-model="sliderModel[0]"
                hide-details
                label="age"
                type="number"
                style="width: 80px"
              ></v-text-field>
            </template>
            <template v-slot:append>
              <v-text-field
                outline
                label="age"
                v-model="sliderModel[1]"
                hide-details
                type="number"
                style="width: 80px"
              ></v-text-field>
            </template>
          </v-range-slider>
      </v-flex>
    </v-layout>
  </v-flex>
</template>
<script>
export default {
  props: ['condition', 'userConditionItems', 'visualItems'],
  data () {
    return {
      selectedVisualItem: this.userConditionItems.filter(userConditionItem => userConditionItem.section === 'photo').find(userConditionItem => userConditionItem.fieldName === this.condition.visualItem),
      sliderModel: this.condition.scaleValue,
      selectedVisualRangeMax: null,
      selectedVisualRangeMin: null
    }
  },
  watch: {
    condition () {
      this.selectedVisualItem = this.userConditionItems.filter(userConditionItem => userConditionItem.section === 'photo').find(userConditionItem => userConditionItem.fieldName === this.condition.visualItem)
    }
  },
  methods: {
    sliderChanged (val) {
      this.condition.scaleValue = Array.from(val)
    },
    selectVisualItem (value) {
      this.condition.visualItem = value.fieldName
      this.condition.visualItemType = value.type
      this.setVisualRange()
    },
    setVisualRange () {
      if (this.selectedVisualItem && this.selectedVisualItem.scale) {
        const vals = this.selectedVisualItem.scale.substring(1, this.selectedVisualItem.scale.length - 1).split('-').map(strNum => parseInt(strNum))
        const maxScale = Math.max(...vals)
        const minScale = Math.min(...vals)

        this.selectedVisualRangeMax = maxScale

        this.selectedVisualRangeMin = minScale
      } else {
        this.selectedVisualRangeMax = 1
        this.selectedVisualRangeMin = 0
      }
    }
  },
  mounted () {
    this.setVisualRange()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/story-edit-view/userPanelCondition.vue